import { Injectable } from '@angular/core';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

@Injectable({
  providedIn: 'root'
})
export class FirebaseFunctionService {
  public functions = getFunctions();

  constructor() {
    if (window.location.href.includes('5500')) {
      console.warn("Emulating functions on localhost:5001");
      connectFunctionsEmulator(this.functions, 'localhost', 5001);
    }
  }
}
